import { HttpResult } from "widgets-for-react"
import { NewsletterPageState } from "./newsletter.state"

export const submitForm: (state: NewsletterPageState, r:string) => Promise<HttpResult<{}>> =
  async (state,r) => {
    try {
      const endpoint = `/api/v1/stb`

      let headers = new Headers()
      headers.append('Content-Type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      const body = {
        email: state.form.email,
        gender: processGender(state.form.gender),
        Recaptcha: r,
        acceptTerms: state.form.acceptTerms,
        name_initials: state.form.initials,
        name_suffix: state.form.insertion,
        name_last: state.form.lastName,
      }

      let res = await fetch(endpoint, {
        method: 'post',
        credentials: 'include',
        headers: headers, 
        body: JSON.stringify(body),
      })

      if (!res.ok) throw Error(res.statusText)

      return {
        kind: 'result',
        status: 200,
        value: {}
      }
    } catch {
      return {
        kind: 'failed',
        status: 500
      }
    }
  }

const processGender = (gender: "man" | "vrouw" | "anders" | "" | undefined) => {
  if (gender === "man") return 1
  if (gender === "vrouw") return 2
  if (gender === "anders") return 3
  return 0
}
